var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiftyPlusPeers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.166 34.167h11.39M80.86 39.861V28.472",
    stroke: "var(--positive)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.278,
    cy: 2.278,
    fill: "var(--positive)",
    r: 2.278
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.389,
    cy: 2.278,
    fill: "var(--positive)",
    r: 2.278
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.611,
    cy: 2.278,
    fill: "var(--positive)",
    r: 2.278
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.722,
    cy: 2.278,
    fill: "var(--positive)",
    r: 2.278
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 2.278,
    fill: "var(--positive)",
    r: 2.278
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.833,
    cy: 2.278,
    fill: "var(--positive)",
    r: 2.278
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.944,
    cy: 2.278,
    fill: "var(--positive)",
    r: 2.278
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.166,
    cy: 2.278,
    fill: "var(--positive)",
    r: 2.278
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.278,
    cy: 2.278,
    fill: "var(--positive)",
    r: 2.278
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.056,
    cy: 2.278,
    fill: "var(--positive)",
    r: 2.278
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.278,
    cy: 11.389,
    r: 2.278,
    fill: "var(--positive)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.389,
    cy: 11.389,
    r: 2.278,
    fill: "var(--positive)"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.611,
    cy: 11.389,
    fill: "var(--positive)",
    r: 2.278
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.722,
    cy: 11.389,
    fill: "var(--positive)",
    r: 2.278
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 11.389,
    r: 2.278,
    fill: "var(--positive)"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.833,
    cy: 11.389,
    fill: "var(--positive)",
    r: 2.278
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.944,
    cy: 11.389,
    fill: "var(--positive)",
    r: 2.278
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.166,
    cy: 11.389,
    fill: "var(--positive)",
    r: 2.278
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.278,
    cy: 11.389,
    fill: "var(--positive)",
    r: 2.278
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.056,
    cy: 11.389,
    fill: "var(--positive)",
    r: 2.278
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.278,
    cy: 20.5,
    r: 2.278,
    fill: "var(--positive)"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.389,
    cy: 20.5,
    r: 2.278,
    fill: "var(--positive)"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.611,
    cy: 20.5,
    fill: "var(--positive)",
    r: 2.278
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.722,
    cy: 20.5,
    fill: "var(--positive)",
    r: 2.278
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 2.278,
    fill: "var(--positive)"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.833,
    cy: 20.5,
    fill: "var(--positive)",
    r: 2.278
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.944,
    cy: 20.5,
    fill: "var(--positive)",
    r: 2.278
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.166,
    cy: 20.5,
    fill: "var(--positive)",
    r: 2.278
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.278,
    cy: 20.5,
    fill: "var(--positive)",
    r: 2.278
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.056,
    cy: 20.5,
    fill: "var(--positive)",
    r: 2.278
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.278,
    cy: 29.611,
    r: 2.278,
    fill: "var(--positive)"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.389,
    cy: 29.611,
    r: 2.278,
    fill: "var(--positive)"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.611,
    cy: 29.611,
    fill: "var(--positive)",
    r: 2.278
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.722,
    cy: 29.611,
    fill: "var(--positive)",
    r: 2.278
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 29.611,
    r: 2.278,
    fill: "var(--positive)"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.833,
    cy: 29.611,
    fill: "var(--positive)",
    r: 2.278
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.944,
    cy: 29.611,
    fill: "var(--positive)",
    r: 2.278
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.056,
    cy: 29.611,
    fill: "var(--positive)",
    r: 2.278
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.278,
    cy: 38.722,
    fill: "var(--positive)",
    r: 2.278
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.389,
    cy: 38.722,
    fill: "var(--positive)",
    r: 2.278
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.611,
    cy: 38.722,
    fill: "var(--positive)",
    r: 2.278
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.722,
    cy: 38.722,
    fill: "var(--positive)",
    r: 2.278
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 38.722,
    fill: "var(--positive)",
    r: 2.278
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.833,
    cy: 38.722,
    r: 2.278,
    fill: "var(--positive)"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.944,
    cy: 38.722,
    fill: "var(--positive)",
    r: 2.278
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.056,
    cy: 38.722,
    fill: "var(--positive)",
    r: 2.278
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiftyPlusPeers);
export default __webpack_public_path__ + "static/media/fifty-plus-peers.e8a98e656852f26021374cd4ea6cd78e.svg";
export { ForwardRef as ReactComponent };